<script lang="ts" setup>
import { RoleEnum } from "~/types/User";
import { useWindowSize } from '@vueuse/core'
import { useNavTabs, type TabItem } from "~/composables/useNavTabs";
import Header from '~/components/layouts/Header.vue'
import Footer from '~/components/layouts/Footer.vue'
import BottomBar from '~/components/custom-ui/BottomBar.vue'
import UserProfileCard from "~/components/pages/office/UserProfileCard.vue";
import MasterModeSwitcher from "~/components/pages/office/MasterModeSwitcher.vue";

const navTabs = useNavTabs()
const userStore = useUserStore();
const route = useRoute()
const { width } = useWindowSize()

const tabList = navTabs.value.filter(item => item.role.includes(userStore.currentRole as RoleEnum))
const isCurrentRoute = (item: TabItem) => {
    return route.path === item.path || item.child_pages.includes(route.path)
}

const isChatPage = computed(() => {
    return width.value && width.value < 1024 && route.name === 'office_chats'
})

</script>

<template>
    <div class="min-h-screen">
        <!-- <LoaderLottieAnimation /> --> <!-- Анимация загрузки (Lottie) -->
        <Header />

        <div class="container h-full mx-auto px-4 lg:min-h-[950px] mb-10 lg:mb-0" :class="{
            '!mb-0': isChatPage
        }">
            <div class="lg:mx-3 my-8 flex justify-start flex-wrap md:flex-nowrap" :class="{
                '!my-4': isChatPage
            }">

                <div class="md:block hidden ys-profile-menu w-full md:w-[230px] lg:w-[272px]">
                    <div class="ys-profile-logo lg:p-3">
                        <UserProfileCard :username="userStore.user?.username"
                            :role="userStore.user?.user_role" :email="userStore.user?.email"
                            :photo="userStore.user?.avatar?.url || userStore.user?.avatar?.formats?.small?.url"
                            @click="navigateTo({ name: 'office' });" />
                    </div>
                    <div class="ys-profile-menu-list">
                        <div v-for="item in userStore.user?.user_roles">
                            <div class="ys-master-mode-box mb-5 flex items-center justify-between"
                                v-if="item === RoleEnum.MASTER">
                                {{ $t("Specialist mode") }}
                                <MasterModeSwitcher />
                            </div>
                        </div>
                        <div class="list-title">{{ $t("MAIN") }}</div>
                        <template v-for="item in tabList">
                            <NuxtLink v-if="item.show_in_desktop"
                                class="ys-profile-menu-item flex items-center my-1 justify-between"
                                :class="{ current: isCurrentRoute(item) }" :to="item.path">
                                <span class="flex items-center">
                                    <Icon v-if="item.icon" size="18" class="menu-item-icon ltr:mr-1 rtl:ml-1"
                                        :class="{ 'text-primary-500': isCurrentRoute(item) }" :name="item.icon" />
                                    {{ $t(item.name) }}
                                </span>
                                <span class="flex items-center">
                                    <span class="new-messages-icon"
                                        v-if="item.name === 'Chats' && userStore.unreadResponsesCount">{{
                                        userStore.unreadResponsesCount }}</span>
                                    <Icon v-if="isCurrentRoute(item)" size="24"
                                        class="text-gray-500 rtl:rotate-180 ltr:ml-2 rtl:mr-2"
                                        name="ri:arrow-drop-right-line" />
                                </span>
                            </NuxtLink>
                        </template>
                        <!-- <NuxtLink v-if="userProfile.Role === 'MASTER'" to="/master-office/promotion">
                            <PagesOfficeMasterMenuPromoPlaque />
                        </NuxtLink> -->
                    </div>


                </div>
                <div class="xl:ltr:border-l xl:rtl:border-r xl:border-gray-200 grow w-full overflow-hidden">
                    <NuxtPage />
                </div>
            </div>
        </div>

        <Footer />
        <BottomBar />
    </div>
</template>

<style scoped lang="scss">
.ys-profile-logo {
    height: 88px;
    gap: 10px;
}


.ys-profile-menu {
    gap: 0;

    .ys-profile-menu-list {
        // height: 222px;
        width: 100%;
        padding: 20px 20px 16px 20px;
        gap: 20px;

        @media(max-width:1024px) {
            padding: 0;
        }

        .list-title {
            height: 24px;
            padding: 4px;
            gap: 8px;
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: 0.04em;
            color: rgba(134, 140, 152, 1);
        }

        .ys-profile-menu-item {
            cursor: pointer;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            letter-spacing: -0.006em;
            color: rgba(82, 88, 102, 1);
            height: 36px;
            padding: 8px 12px 8px 12px;
            gap: 8px;
            border-radius: 8px;

            &:hover {
                color: rgba(10, 13, 20, 1);
                background: rgba(246, 248, 250, 1);
            }

            &:active {
                color: rgba(10, 13, 20, 1);
                background: rgba(246, 248, 250, 1);
            }
        }

        .current {
            color: rgba(10, 13, 20, 1);
            background: rgba(246, 248, 250, 1);

            .menu-item-icon {
                color: rgba(45, 159, 117, 1);
            }
        }
    }
}

.ys-master-mode-box {
    width: 100%;
    height: 36px;
    padding: 8px;
    gap: 8px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.006em;
    text-align: left;
    color: rgba(10, 13, 20, 1);
}
</style>